import React from 'react';

import { CleaningPrestation, User } from '@front/common/src/types/commons';
import { BasketState } from '@front/common/src/ducks/common/basket';

import { hasMembership, hasPaidMembership, hasRecurrentMembership } from '@front/customer/src/utils/membership';
import { Price } from '@front/customer/src/types/prices';

import PaidMembership from './paid-membership';
import RecurrentMembership from './recurrent-membership';
import NoMembershipYet from './no-membership-yet';

type MembershipCardContentProps = {
  isMembershipRequested: boolean;
  user?: User;
  getMoreInfoPress: () => void;
  duration: BasketState['duration'];
  cleaningPrestation?: CleaningPrestation;
  reduction: Price;
};

const MembershipCardContent = ({
  isMembershipRequested,
  user,
  getMoreInfoPress,
  duration,
  cleaningPrestation,
  reduction,
}: MembershipCardContentProps) => {
  const isMembershipPresent = hasMembership(user);
  const isPaidMembership = hasPaidMembership(user);
  const isRecurrentMembership = hasRecurrentMembership(user);

  if (isPaidMembership) {
    return (
      <PaidMembership
        reduction={reduction}
        getMoreInfoPress={getMoreInfoPress}
        duration={duration}
        cleaningPrestation={cleaningPrestation}
      />
    );
  }

  if (isRecurrentMembership) {
    return (
      <RecurrentMembership
        reduction={reduction}
        getMoreInfoPress={getMoreInfoPress}
        duration={duration}
        cleaningPrestation={cleaningPrestation}
      />
    );
  }

  if (!isMembershipPresent) {
    return (
      <NoMembershipYet
        reduction={reduction}
        getMoreInfoPress={getMoreInfoPress}
        duration={duration}
        cleaningPrestation={cleaningPrestation}
        isMembershipRequested={isMembershipRequested}
      />
    );
  }

  return null;
};

export default MembershipCardContent;
